//* Components
import Container from 'components/common/Container';
import Text from 'components/common/Text';
import FullVideoImage from 'components/common/FullVideoImage';
import DangerDescription from 'components/common/DangerDescription';

//* Style
import DescriptiveSecondaryStyle from './style';

const DescriptiveSecondary = ({ title, subtitle, file, description, first }) => {
	return (
		<DescriptiveSecondaryStyle>
			<Container
				first={first}
				full
			>
				<Container>
					{title && (
						<Text
							tag={'h2'}
							className={'h3 font-ping-bolder title'}
							text={title}
						/>
					)}
					{subtitle && (
						<Text
							tag={'h3'}
							className={'h4 font-ping-regular subtitle'}
							text={subtitle}
						/>
					)}
				</Container>
				<FullVideoImage
					file={file}
					alt={title}
				/>
				{description && <DangerDescription descriptions={description} />}
			</Container>
		</DescriptiveSecondaryStyle>
	);
};

export default DescriptiveSecondary;
